import React, { useState, useEffect } from "react";

import { Card, CardContent, CardHeader } from "./ui/card";
import { Dialog, DialogTrigger, DialogContent, DialogClose } from "./ui/dialog";
import home from "../assets/images/homeIcon.svg";
import CurrencyFormatter from "../utils/currencyFormatter";
import prod1 from "../assets/images/imageProd.png";
import {
  Bath,
  Bed,
  ChevronDown,
  MapPin,
  CarFront,
  Eye,
  X,
  Loader,
  CircleCheck,
  Grid2X2,
} from "lucide-react";
import gallery1 from "../assets/images/gal1.jpg";
import InvestPropertyGalleryCarousel from "./InvestPropertyGalleryCarousel";
import { Button } from "./ui/button";
import { InvestProductHistory } from "./InvestProductHistory";
import StringFormatter from "../utils/stringFormatter";
export default function InvestOwnedProduct({
  ledgerProduct,
  isExploreDisabled,
}) {
  const asset = ledgerProduct?.productId?.assetId?.asset;
  const depositType = ledgerProduct?.productId?.depositFee?.feeType;
  const withdrawalType = ledgerProduct?.productId?.withdrawalFee?.feeType;
  // const withdrawalFee =
  //   ledgerProduct?.productId?.withdrawalFee?.feeAmount?.$numberDecimal;
  // const depositFee =
  //   ledgerProduct?.productId?.depositFee?.feeAmount?.$numberDecimal;
  const withdrawalFee = 0;
  const depositFee = 0;

  const [openSeeMore, setOpenSeeMore] = useState(false);
  const [openSeeMoreSecondary, setOpenSeeMoreSecondary] = useState(false);
  const [index, setIndex] = useState(null);

  const assetType = ledgerProduct?.productId?.assetId?.asset;

  const formatter = new CurrencyFormatter();
  const OPTIONS = { loop: true };
  const slides =
    ledgerProduct?.productId?.imageUrls?.length > 0
      ? ledgerProduct?.productId?.imageUrls
      : gallery1;

  const [bgImage, setBgImage] = useState(slides[index]);

  const toggleAccordionSeeMore = () => setOpenSeeMore((prev) => !prev);

  useEffect(() => {
    const delay = setTimeout(() => {
      setBgImage(slides[index]);
    }, 600);

    return () => clearTimeout(delay);
  }, [index, slides]);

  const toggleAccordionSecond = () => {
    setOpenSeeMoreSecondary((prev) => !prev);
  };

  const string = new StringFormatter();

  return (
    <div className="col-span-4">
      <div className="py-3 mb-2">
        <Card>
          <CardHeader>
            <div className="flex justify-between items-center">
              <div className="flex gap-3">
                <div>
                  <img src={home} alt="house icon" className="w-20 h-20" />
                </div>
                <div>
                  <h2 className="font-bold text-3xl text-gray-800">
                    {ledgerProduct?.productId?.name}
                  </h2>
                  {ledgerProduct?.productId?.moreDetails && (
                    <p className="flex items-center text-gray-700 mt-1">
                      <MapPin className="w-4 h-4" />
                      {ledgerProduct?.productId?.moreDetails?.location}
                    </p>
                  )}
                  <p className="mt-4 text-gray-600">
                    {ledgerProduct?.productId?.description}
                  </p>
                </div>
              </div>

              {!isExploreDisabled ? (
                <>
                  {ledgerProduct?.productId?.status === "pending" ? (
                    <div className="flex self-start gap-2 bg-yellow-200 text-yellow-700 px-3 py-1 rounded-full">
                      <Loader />
                      {ledgerProduct?.productId?.status
                        .charAt(0)
                        .toUpperCase() +
                        ledgerProduct?.productId?.status.slice(1)}
                    </div>
                  ) : ledgerProduct?.productId?.status === "active" ? (
                    <div className="flex self-start gap-2 bg-emerald-200 text-emerald-700 px-3 py-1 rounded-full">
                      <CircleCheck />
                      {ledgerProduct?.productId?.status
                        .charAt(0)
                        .toUpperCase() +
                        ledgerProduct?.productId?.status.slice(1)}
                    </div>
                  ) : (
                    <div className="flex self-start gap-2 bg-purple-200 text-purple-700 px-3 py-1 rounded-full">
                      <Loader /> +
                      {ledgerProduct?.productId?.status
                        .charAt(0)
                        .toUpperCase() +
                        ledgerProduct?.productId?.status.slice(1)}
                    </div>
                  )}
                </>
              ) : (
                <>
                  {ledgerProduct?.status === "pending" ? (
                    <div className="flex self-start gap-2 bg-yellow-200 text-yellow-700 px-3 py-1 rounded-full">
                      <Loader />
                      {ledgerProduct?.status.charAt(0).toUpperCase() +
                        ledgerProduct?.status.slice(1)}
                    </div>
                  ) : ledgerProduct?.status === "active" ? (
                    <div className="flex self-start gap-2 bg-emerald-200 text-emerald-700 px-3 py-1 rounded-full">
                      <CircleCheck />
                      {ledgerProduct?.status.charAt(0).toUpperCase() +
                        ledgerProduct?.status.slice(1)}
                    </div>
                  ) : (
                    <div className="flex self-start gap-2 bg-purple-200 text-purple-700 px-3 py-1 rounded-full">
                      <Loader /> +
                      {ledgerProduct?.status.charAt(0).toUpperCase() +
                        ledgerProduct?.status.slice(1)}
                    </div>
                  )}
                </>
              )}
            </div>
          </CardHeader>
          <CardContent>
            <Dialog>
              <div className="relative group rounded-3xl overflow-hidden h-96">
                <img
                  src={
                    ledgerProduct?.productId?.imageUrls.length > 0
                      ? ledgerProduct?.productId?.imageUrls[0]
                      : prod1
                  }
                  alt="flats"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {ledgerProduct?.productId?.imageUrls?.length > 0 && (
                    <DialogTrigger asChild>
                      <button className="w-14 h-14 rounded-full border-2 border-white flex items-center justify-center hover:bg-white/10 transition">
                        <Eye className="text-white w-6 h-6" />
                      </button>
                    </DialogTrigger>
                  )}
                </div>
              </div>

              <DialogContent className="!rounded-none bg-black/70  backdrop-blur-md p-0 m-0 border-none shadow-none max-w-screen h-screen flex flex-col z-50">
                <div className="absolute inset-0 z-0 transition-opacity duration-700 ease-in-out">
                  <img
                    key={index}
                    src={bgImage}
                    alt="Backdrop"
                    className="w-full h-full object-cover blur-2xl opacity-30 transition-all duration-700 ease-in-out"
                  />
                  <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full h-full flex flex-col justify-between">
                  <div className="relative w-full flex items-center justify-center py-6">
                    <h2 className="text-white text-2xl font-semibold">
                      Gallery
                    </h2>

                    <DialogClose>
                      <Button
                        variant="ghost"
                        className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
                      >
                        <X size={18} className="text-white" />
                      </Button>
                    </DialogClose>
                  </div>

                  <div className="w-full h-px bg-white/10 mb-4" />

                  <div className="flex-1 w-full flex items-center justify-center ">
                    <InvestPropertyGalleryCarousel
                      slides={slides}
                      options={OPTIONS}
                      navClass="carousel-two"
                      setIndex={setIndex}
                    />
                  </div>
                </div>
              </DialogContent>
            </Dialog>

            <p className="mt-5 mb-1 font-bold text-gray-500">
              Investment Details
            </p>
            <div className="border rounded-lg divide-y">
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Value</span>
                <span className="text-sm font-medium text-gray-800">
                  {formatter.format(
                    ledgerProduct?.productId?.value?.$numberDecimal,
                    ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                  )}
                </span>
              </div>
              {!isExploreDisabled && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Capital</span>
                  <span className="text-sm font-medium text-gray-800">
                    {formatter.format(
                      ledgerProduct?.capital,
                      ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                    )}
                  </span>
                </div>
              )}
              {!isExploreDisabled && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Balance</span>
                  <span className="text-sm font-medium text-gray-800">
                    {formatter.format(
                      ledgerProduct?.balance,
                      ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                    )}
                  </span>
                </div>
              )}
              {!isExploreDisabled && (
                <div className="p-4 flex justify-between">
                  <span className="text-sm text-gray-700">Profit</span>
                  <span className="text-sm font-medium text-gray-800">
                    {formatter.format(
                      ledgerProduct?.profit,
                      ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                    )}
                  </span>
                </div>
              )}
              {/* <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">Income</span>
                <span className="text-sm font-medium text-gray-800">
                  {formatter.format(
                    ledgerProduct?.productId?.income?.$numberDecimal,
                    ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                  )}
                </span>
              </div> */}
              <div className="p-4 flex justify-between">
                <span className="text-sm text-gray-700">ROI</span>
                <span className="text-sm font-medium text-gray-800">
                  {ledgerProduct?.productId?.roi?.$numberDecimal} %
                </span>
              </div>

              {openSeeMore && (
                <>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">Asset</span>
                    <span className="text-sm font-medium text-gray-800">
                      {ledgerProduct?.productId?.assetId?.asset?.toUpperCase()}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Investment Term
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {ledgerProduct?.productId?.duration?.period}{" "}
                      {ledgerProduct?.productId?.duration?.unit}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Investment Type
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {string.capitalizeFirst(
                        ledgerProduct?.productId?.investmentType
                      )}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Minimum Investment
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        ledgerProduct?.productId?.minDeposit?.$numberDecimal,
                        ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Maximum Investment
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        ledgerProduct?.productId?.maxDeposit?.$numberDecimal,
                        ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div>
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Deposit Fee Type
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {string.capitalizeFirst(depositType)}
                    </span>
                  </div> */}
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Deposit Fee Amount
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {depositType === "fixed"
                        ? formatter.format(depositFee, asset?.toUpperCase())
                        : depositFee + "%"}
                    </span>
                  </div>
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Withdrawal Fee Type
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {string.capitalizeFirst(withdrawalType)}
                    </span>
                  </div> */}
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Withdrawal Fee Amount
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {withdrawalType === "fixed"
                        ? formatter.format(withdrawalFee, asset?.toUpperCase())
                        : withdrawalFee + "%"}
                      {}{" "}
                    </span>
                  </div>
                  {/* <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Profit Amount for{" "}
                      {ledgerProduct?.productId?.durationInYearOrMonth?.[0]}
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        ledgerProduct?.productId?.amountForEachYearOrMonth?.[0],
                        ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700">
                      Profit Amount for{" "}
                      {ledgerProduct?.productId?.durationInYearOrMonth?.[1]}
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {formatter.format(
                        ledgerProduct?.productId?.amountForEachYearOrMonth?.[1],
                        ledgerProduct?.productId?.assetId?.asset?.toUpperCase()
                      )}
                    </span>
                  </div> */}
                </>
              )}

              <div className="p-4">
                <div
                  onClick={toggleAccordionSeeMore}
                  className="flex justify-between cursor-pointer items-center"
                >
                  <span className="text-sm text-gray-700">
                    {openSeeMore ? "See Less" : "See More"}
                  </span>
                  <span
                    className="text-sm font-medium text-gray-600 transition-transform"
                    style={{
                      transform: openSeeMore
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <ChevronDown />
                  </span>
                </div>
              </div>
            </div>
            {ledgerProduct?.productId?.moreDetails && (
              <>
                <p className="mt-5 mb-1 font-bold text-gray-500">
                  Property Details
                </p>
                <div className="border rounded-lg divide-y">
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700 flex gap-1 items-center">
                      <Bed className="w-4 h-4" /> Bedrooms
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {ledgerProduct?.productId?.moreDetails?.bedrooms}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700 flex gap-1 items-center">
                      <Bath className="w-4 h-4" /> Bathrooms
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {ledgerProduct?.productId?.moreDetails?.bathrooms}
                    </span>
                  </div>
                  <div className="p-4 flex justify-between">
                    <span className="text-sm text-gray-700 flex gap-1 items-center">
                      <CarFront className="w-4 h-4" /> Parking
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {ledgerProduct?.productId?.moreDetails?.parking}
                    </span>
                  </div>
                  {openSeeMoreSecondary && (
                    <>
                      <div className="p-4 flex justify-between">
                        <span className="text-sm text-gray-700 flex gap-1 items-cente">
                          <Grid2X2 className="w-4 h-4" /> Area
                        </span>
                        <span className="text-sm font-medium text-gray-800">
                          {ledgerProduct?.productId?.moreDetails?.area}m2
                        </span>
                      </div>
                    </>
                  )}
                  <div className="p-4">
                    <div
                      onClick={toggleAccordionSecond}
                      className="flex justify-between cursor-pointer items-center"
                    >
                      <span className="text-sm text-gray-700">
                        {openSeeMoreSecondary ? "See Less" : "See More"}
                      </span>
                      <span
                        className="text-sm font-medium text-gray-600 transition-transform"
                        style={{
                          transform: openSeeMore
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <ChevronDown />
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* 
            {!isExploreDisabled && (
              <div className="flex justify-center items-center mt-8 gap-3">
                <div>
                  <button
                    onClick={() => {}}
                    className="py-3 px-24 text-sm font-bold text-black border border-gray-300 rounded-full bg-white hover:opacity-90"
                  >
                    Generate Report
                  </button>
                </div>
              </div>
            )} */}
          </CardContent>
        </Card>
      </div>
      {!isExploreDisabled && (
        <InvestProductHistory ledgerId={ledgerProduct?._id} asset={assetType} />
      )}
    </div>
  );
}
